module.exports = __webpack_public_path__ + "templates/about-where.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/about/templates/about-where.html
// module id = DmwU
// module chunks = 1